import * as React from 'react';
import styles from './style.module.less';
import type { IProps } from './interface';
import { ReoIcon } from '@reolink-web/components.basic';
import classnames from 'classnames';

const Loading: React.FC<IProps> = (props) => {
    const handleClickMask = React.useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
    }, []);

    if (props.isLoading === false) {
        return null;
    }

    return (
        <div
            className={ classnames(
                `${styles.mask} ${props.type === 'partial' ? styles['partial'] : ''}`,
                props.className,
            ) }
            onClick={ handleClickMask }
        >
            <div className={ styles['loading-icon-wrapper'] }>
                <ReoIcon
                    name={ props.icon ?? 'icon-icon-loading-2' }
                    width={ props.iconWidth ?? 40 }
                    color={ props.iconColor ?? '#777' }
                    className={ styles.loading }
                />
            </div>

            {props.children}
        </div>
    );
};

export default Loading;
